
export default class Error {
    constructor(public message: string, public options?: { cause: unknown }) { }
}